import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import passIcon from '../assets/pass-icon.png';
import { trackPageView } from '../utils/analytics';

const ZipWithPasswordPrivacy = () => {
  useEffect(() => {
    trackPageView('ZipWithPassword Privacy Policy');
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon">
            <img src={passIcon} alt="ZipWithPassword" />
          </div>
          <div className="app-details">
            <h1>ZipWithPassword</h1>
            <p>Privacy Policy</p>
          </div>
        </div>
        <Link to="/" className="back-link">← Back to Home</Link>
      </header>

      <main className="privacy-content">
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>ZipWithPassword is designed with privacy in mind. We do not collect, store, or transmit any personal information or file contents. All compression and encryption operations are performed locally on your device.</p>
        </div>

        <div className="privacy-section">
          <h2>Data Processing</h2>
          <p>All file processing, including compression and password protection, happens entirely on your device. Your files and passwords never leave your device or get transmitted to our servers.</p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>ZipWithPassword does not integrate with any third-party analytics, advertising, or data collection services. The app operates completely offline.</p>
        </div>

        <div className="privacy-section">
          <h2>Data Security</h2>
          <p>Since no data is collected or transmitted, there are no security risks related to data breaches or unauthorized access to your personal information through our app.</p>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>Email:</strong> feedback@peacetech.app</p>
        </div>

        <div className="privacy-section">
          <h2>Updates to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          <p><strong>Last updated:</strong> January 2025</p>
        </div>
      </main>
    </div>
  );
};

export default ZipWithPasswordPrivacy;